import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Html from "./html";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const Category = () => {
  const user = useSelector((state) => state.user);
  const searchState = { data: "" };
  const [filters, setFilter] = useState({ page: 1, count: 10, search: "" });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const history = useNavigate();

  useEffect(() => {
      setFilter({ ...filters, search: searchState.data });
      getData({ search: searchState.data });
  }, [])

  const getData = (p = {}) => {
    loader(true)
    let filter = { ...filters, ...p }
    ApiClient.get("category/listing", filter).then((res) => {
      if (res.success) {
        setData(res?.data)
        setTotal(res.total)
      }
      loader(false)
    })
  }

  const clear = () => {
    let f = {
      type: "",
      search: "",
      status: "",
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  }
  const filter = (p = {}) => {
    let f = {
      ...p,
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  }

  const deleteCategory = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete this category`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true);
        ApiClient.delete(`category/delete?id=${id}`).then((res) => {
          if (res.success) {
            clear();
          }
          else {
            toast?.error(res?.message)
          }
          loader(false)
        })
      }
    })
  }

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  }
  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  }
  const changestatus = (e) => {
    setFilter({ ...filters, status: e });
    getData({ status: e });
  }

  const statusChange = (itm) => {
    let status = "active";
    if (itm.status == "active") status = "deactive";
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${itm == "active" ? "Activate" : "Deactivate"
        } this category`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        let value = {
          status: status,
          id: itm?._id || itm?.id
        }
        loader(true);
        ApiClient.put("category/status/change", value).then((res) => {
          if (res.success) {
            getData()
          }
          else {
            toast?.error(res?.message)
          }
          loader(false)
        })
      }
    })
  }

  const edit = (id) => {
    history(`/category/edit/${id}`)
  }
  const view = (id) => {
    let url = `/category/detail/${id}`
    history(url)
  }

  const isAllow = (key = "") => {
    if (user?.role?.name == "admin") return true
    let permissions = user?.role?.permissions?.[0]
    let value = permissions?.[key]
    return value;
  }

  const handleSearch = (e) => {
    setFilter({ ...filters, search: e.target.value });
    if (e.target.value === "") {
      getData({ search: "" })
    }
  }

  return (
    <>
      <Html
        edit={edit}
        view={view}
        clear={clear}
        isAllow={isAllow}
        count={count}
        pageChange={pageChange}
        deleteCategory={deleteCategory}
        filters={filters}
        setFilter={setFilter}
        filter={filter}
        data={data}
        total={total}
        statusChange={statusChange}
        changestatus={changestatus}
        handleSearch={handleSearch}
      />
    </>
  );
};

export default Category;
